var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconTagLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconTag",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1152.821 372.968c-2.453 17.493-4.693 35.093-4.693 53.333 0 18.24 2.24 36.16 4.907 53.974-56.214-1.28-112.96 19.093-155.734 61.866-83.093 83.094-83.093 218.56 0 301.654 41.6 41.6 96.214 62.4 150.827 62.4s109.227-20.8 150.827-62.4c83.093-83.094 83.093-218.56 0-301.654-8.214-8.213-17.387-15.146-26.56-21.653l-.747-2.027c-11.093-29.866-16.853-60.906-16.853-92.16 0-18.453 2.346-36.053 6.186-53.333h153.814c29.333 0 53.333 24 53.333 53.333v625.494l-638.4 638.506-678.933-678.933 638.506-638.4h363.52Zm-4.693 213.44c14.827 0 29.227 3.627 42.987 9.707 16 31.68 36.48 60.48 61.44 86.08 3.306 30.826-5.44 62.613-29.014 86.186-41.706 41.707-109.12 41.707-150.826 0-41.6-41.6-41.6-109.226 0-150.826 20.8-20.8 48.106-31.147 75.413-31.147Zm373.333-533.44c-146.24 0-276.48 85.333-335.68 213.333h-440.64L-.032 1011.368l829.76 829.76 745.067-745.173V426.3c0-88.213-71.787-160-160-160h-106.347c48.853-65.706 127.147-106.666 213.013-106.666 147.094 0 266.667 119.573 266.667 266.666h106.667c0-205.866-167.467-373.333-373.334-373.333Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconTagLine.glyphName = 'tag';
IconTagLine.variant = 'Line';
IconTagLine.displayName = 'IconTagLine';
IconTagLine.allowedProps = [...SVGIcon.allowedProps];
export default IconTagLine;
export { IconTagLine };